import { render, staticRenderFns } from "./RegisterPemberitahuanResiko.vue?vue&type=template&id=16921c7e&scoped=true&"
import script from "./RegisterPemberitahuanResiko.vue?vue&type=script&lang=js&"
export * from "./RegisterPemberitahuanResiko.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPemberitahuanResiko.vue?vue&type=style&index=0&id=16921c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16921c7e",
  null
  
)

export default component.exports